import React, {Component} from 'react';
import styles from "../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import {withTranslation} from "react-i18next";
import Select from "../../../../../components/select/Select"
import Autocomplete from "../../../../../components/autocomplete/Autocomplete";

class InfoClinicheAggiuntive extends Component {

    state = {
        infoClinicheAggiuntive: {
            statoInVitaDiagnosi: "",
            dataInizioTerapia: "",
            strutturaSanitaria: "",
            giaTrattatoInPassato: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? "3*" : "",
            corretto: []
        },
        struttureAndStabilimenti: JSON.parse(sessionStorage.getItem("struttureAndStabilimenti")),
        struttureAndStabilimentiPerCodice: JSON.parse(sessionStorage.getItem("struttureAndStabilimentiPerCodice")),
    }

    constructor(props) {
        super(props);
        this.setGiaTrattatoInPassato = this.setGiaTrattatoInPassato.bind(this)
        this.setStatoInVitaDiagnosi = this.setStatoInVitaDiagnosi.bind(this)
        this.setStrutturaSanitaria = this.setStrutturaSanitaria.bind(this)
        this.setDataInizioTerapia = this.setDataInizioTerapia.bind(this)
        this.controlloDati = this.controlloDati.bind(this);
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {

        this.props.setInfoClinicheAggiuntive(undefined, this)
        if (this.props.segnalazioneCopia.datiSpecifici) {
            if (this.props.segnalazioneCopia.datiSpecifici.infoClinicheAggiuntive) {
                let infoClinicheAggiuntive = this.state.infoClinicheAggiuntive;
                let infoClinicheAggiuntiveCopia = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici))
                infoClinicheAggiuntive.statoInVitaDiagnosi = infoClinicheAggiuntiveCopia.infoClinicheAggiuntive.statoInVitaDiagnosi ? infoClinicheAggiuntiveCopia.infoClinicheAggiuntive.statoInVitaDiagnosi : ""
                infoClinicheAggiuntive.dataInizioTerapia = infoClinicheAggiuntiveCopia.infoClinicheAggiuntive.dataInizioTerapia ? infoClinicheAggiuntiveCopia.infoClinicheAggiuntive.dataInizioTerapia : ""
                infoClinicheAggiuntive.strutturaSanitaria = infoClinicheAggiuntiveCopia.infoClinicheAggiuntive.strutturaSanitaria && this.state.struttureAndStabilimentiPerCodice[infoClinicheAggiuntiveCopia.infoClinicheAggiuntive.strutturaSanitaria] ? this.state.struttureAndStabilimentiPerCodice[infoClinicheAggiuntiveCopia.infoClinicheAggiuntive.strutturaSanitaria] : ""
                infoClinicheAggiuntive.giaTrattatoInPassato = infoClinicheAggiuntiveCopia.infoClinicheAggiuntive.giaTrattatoInPassato ? infoClinicheAggiuntiveCopia.infoClinicheAggiuntive.giaTrattatoInPassato : ""

                this.setState({infoClinicheAggiuntive: infoClinicheAggiuntive})
                this.props.setInfoClinicheAggiuntive(this.state.infoClinicheAggiuntive)
            }
        }
        this.controlloDati()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            this.props.setInfoClinicheAggiuntive(this.state.infoClinicheAggiuntive, this)
        }
    }

    controlloDati() {
        let controllo = this.state.infoClinicheAggiuntive;
        controllo.corretto = []

        if(!this.state.infoClinicheAggiuntive.statoInVitaDiagnosi){
            controllo.corretto[0] = "Campo \"Stato in vita al momento della diagnosi\" mancante"
        }
        if(!this.state.infoClinicheAggiuntive.giaTrattatoInPassato){
            controllo.corretto[1] = "Campo \"Già trattato in passato\" mancante"
        }
        if(controllo.dataInizioTerapia && Utils.isDateInValid(Utils.transformDateForBackend(controllo.dataInizioTerapia), "-")){
            controllo.corretto[2] = "Campo \"Data inizio terapia\" errato"
        }

        this.setState({infoClinicheAggiuntive: controllo})
    }

    validate() {
        let validateDataInizioTerapia = Utils.checkDateInterval(this.state.infoClinicheAggiuntive.dataInizioTerapia, "31/12/1899");
        let checkTodayDataInizioTerapia = Utils.checkDateLowerToday(this.state.infoClinicheAggiuntive.dataInizioTerapia);
        if (validateDataInizioTerapia) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_0Q"]), 1
            )
        } else if (checkTodayDataInizioTerapia) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_0R"]), 1
            )
        } else if (!this.state.infoClinicheAggiuntive.dataInizioTerapia && this.state.infoClinicheAggiuntive.strutturaSanitaria && this.state.strutture && this.state.strutture.length > 0) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_BN"]), 1
            )
        }

        let infoCliniche = Object.assign({}, this.state.infoClinicheAggiuntive)
        let infoClinicheObj = Utils.removeFieldFromObject(infoCliniche, "corretto");

        let res = Utils.removeEmptyValueFromObject(infoClinicheObj);
        if (res.strutturaSanitaria && res.strutturaSanitaria.codice) {
            res.strutturaSanitaria = res.strutturaSanitaria.codice
        }

        this.props.setInfoClinicheAggiuntive(undefined, undefined, res)
    }

    setStatoInVitaDiagnosi(event) {
        let infoClinicheAggiuntive = this.state.infoClinicheAggiuntive
        infoClinicheAggiuntive.statoInVitaDiagnosi = event.target.value
        this.setState({infoClinicheAggiuntive: infoClinicheAggiuntive})
        this.controlloDati();
    }

    setStrutturaSanitaria(field, event) {
        let infoClinicheAggiuntive = this.state.infoClinicheAggiuntive
        infoClinicheAggiuntive.strutturaSanitaria = event.target.value
        this.setState({infoClinicheAggiuntive: infoClinicheAggiuntive})
        this.controlloDati()
    }

    setGiaTrattatoInPassato(event) {
        let infoClinicheAggiuntive = this.state.infoClinicheAggiuntive
        infoClinicheAggiuntive.giaTrattatoInPassato = event.target.value
        this.setState({infoClinicheAggiuntive: infoClinicheAggiuntive})
        this.controlloDati();
    }

    setDataInizioTerapia(field) {
        let infoClinicheAggiuntive = this.state.infoClinicheAggiuntive
        if (field && field.currentTarget) {
            if (field.currentTarget.id === "dataInizioTerapia") {
                infoClinicheAggiuntive.dataInizioTerapia = field.target.value;
            }
        }
        this.setState({infoClinicheAggiuntive: infoClinicheAggiuntive})
        this.controlloDati()
    }

    render() {
        const {t} = this.props
        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{this.props.t("DatiSpecifici.InfoClinicheAggiuntive.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>

                    <div className={"row"}>
                        <div className="col-lg-6">
                            <p style={{color: "#1b7ea9"}}>{this.props.t("DatiSpecifici.InfoClinicheAggiuntive.statoDiagnosi")}<span
                                className={styles.mandatoryColor}>*</span></p>
                            <Select
                                value={this.state.infoClinicheAggiuntive.statoInVitaDiagnosi}
                                onChange={this.setStatoInVitaDiagnosi}
                                style={{width: "100%"}}
                                functionMap={Utils.mapToArray(OggettiUtili.InfoClinicheAggiuntive).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >
                            </Select>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "1rem"}}>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p style={{color: "#1b7ea9"}}>
                                {this.props.t("DatiSpecifici.InfoClinicheAggiuntive.dataTerapia")}
                            </p>
                            <Calendar
                                id={"dataInizioTerapia"} value={this.state.infoClinicheAggiuntive.dataInizioTerapia}
                                field={"dataInizioTerapia"}
                                onChange={this.setDataInizioTerapia}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    t("Data inizio terapia"))}
                                error={(this.state.infoClinicheAggiuntive.dataInizioTerapia === "" ||
                                    this.state.infoClinicheAggiuntive.dataInizioTerapia == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.infoClinicheAggiuntive.dataInizioTerapia), "-")}
                            >
                            </Calendar>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9"}}>{this.props.t("DatiSpecifici.InfoClinicheAggiuntive.struttura")}</p>
                            <Autocomplete id={"strutturaSanitaria"}
                                          value={this.state.infoClinicheAggiuntive.strutturaSanitaria}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.setStrutturaSanitaria}
                                          field={"strutturaSanitaria"}
                                          placeholder={t("DatiSpecifici.InfoClinicheAggiuntive.struttura")}
                                          suggestions={this.state.struttureAndStabilimenti}
                            >
                            </Autocomplete>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9"}}>{this.props.t("DatiSpecifici.InfoClinicheAggiuntive.trattato")}<span
                                className={styles.mandatoryColor}>*</span></p>
                            <Select value={this.state.infoClinicheAggiuntive.giaTrattatoInPassato === "3*"? "3" : this.state.infoClinicheAggiuntive.giaTrattatoInPassato}
                                    onChange={this.setGiaTrattatoInPassato}
                                    style={{width: "100%"}}
                                    functionMap={Utils.mapToArray(OggettiUtili.GiaTrattatoInPassato).map((oggetto) => {
                                        return (<option value={oggetto.codice} style={{backgroundColor:'white'}}>{oggetto.descrizione}</option>)
                                    })}
                                    addclass={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.infoClinicheAggiuntive.giaTrattatoInPassato === "3*"? 'select-yellow' : !this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                            >
                            </Select>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default withTranslation('common')(InfoClinicheAggiuntive)
